import { MapIcon } from "@heroicons/react/24/solid"
import Button from "../ui/Button"
import { useContext, useState } from "react"
import Modal from "../ui/Modal"
import { AdminContext } from "~/contexts/AdminContext"
import Image from "../ui/Image"
import Tooltip from "../ui/Tooltip"
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch"

const CampMap: React.FC = () => {
  const { camp } = useContext(AdminContext)
  const [openModal, setOpenModal] = useState<boolean>(false)

  return (
    <Tooltip content="View Map">
      <Button onClick={() => setOpenModal(true)}>
        <MapIcon className="text-gray-500 h-6 w-6" />
      </Button>

      {openModal && (
        <Modal open onClose={() => setOpenModal(false)}>
          <TransformWrapper>
            <TransformComponent
              wrapperStyle={{ width: "100%", height: "100%" }}
              contentStyle={{ width: "100%", height: "100%" }}
            >
              <div className="flex justify-center items-center w-full h-[80vh] relative">
                <Image src={camp.map_url} alt={camp.address} />
              </div>
            </TransformComponent>
          </TransformWrapper>
        </Modal>
      )}
    </Tooltip>
  )
}

export default CampMap
